import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-four"
import Footer from "@layout/footer/footer-one"
import PageHeader from "@components/pageheader"
import BoxSolutions from "@containers/processes-solutions"
import { processesSolutions } from "../dataMantiz/pages/processesSolutions/processesSolutions"

const ProcessesSolutionsPage = ({ pageContext, location }) => {
  return (
    <Layout location={location}>
      <Seo title={processesSolutions.label} />
      <Header />
      <PageHeader
        pageContext={pageContext}
        location={location}
        title={processesSolutions.title}
        customLabel={processesSolutions.label}
      />
      <main className="site-wrapper-reveal">
        <BoxSolutions />
      </main>
      <Footer />
    </Layout>
  )
}

export default ProcessesSolutionsPage
